import React, { useEffect, useState } from 'react'
import { Route, HashRouter } from 'react-router-dom'
import fetch from 'isomorphic-fetch'
import LandingPage from './LandingPage'
import Timeline from './components/Timeline'
import { isMobile } from 'react-device-detect'
import { formatData } from './utils/format'
import ScrollToTopOnMount from './components/ScrollToTopOnMount'

import './css/common.scss'
import './css/Typography.scss'

function Main () {
  const [data, setData] = useState({
    industries: {},
    times: {}
  })
  const [pageReady, setPageReady] = useState(false)
  const [mobileDevice, setMobileDevice] = useState(false)

  useEffect(() => {
    const toFetch = './data/timeline.json'

    const fetchData = async () => {
      const response = await fetch(toFetch)
      const data = await response.json()
      if (data.error) {
        const err = new Error()
        err.code = 'ENOENT'
        throw err
      } else {
        setData(formatData(data))
        setPageReady(true)
        setMobileDevice(isMobile)
      }
    }
    fetchData()
  }, [])
  return (
    <HashRouter>
      
      <div className={`content ${mobileDevice ? 'isMobile' : ''}`}>
        <Route exact path='/'
          render={props => pageReady ? <ScrollToTopOnMount><LandingPage {...props} data={data} /></ScrollToTopOnMount> : ''} />
        <Route exact path={`/:collectionType/:narrative`}
          render={props => pageReady ? <ScrollToTopOnMount><Timeline data={data} industries={data.industries} narratives={data.narratives} times={data.times} {...props} /></ScrollToTopOnMount> : ''} />
        <Route exact path={`/:collectionType/:narrative/:timepoint`}
          render={props => pageReady ? <ScrollToTopOnMount><Timeline data={data} industries={data.industries} times={data.times} {...props} /></ScrollToTopOnMount> : ''} />
      </div>
    </HashRouter>
  )
}

export default Main
